// extracted by mini-css-extract-plugin
export default {"optionalText":"InputTextField_optionalText__4ifJL","errorText":"InputTextField_errorText__CbmXj","hotizontalContainer":"InputTextField_hotizontalContainer__aBOpO"};